import { firestore } from '../lib/db';
import { getIdFromUID, cleanFirebaseId, createEpisodeObj, reviewsLimit, cleanGUID } from '../lib/utils';
import { createReviewId, createReview } from '../lib/reviewUtils';
import { Timestamp, deleteDoc, deleteField, collection, query, where, getDoc, getDocs, doc, orderBy, limit, setDoc } from "firebase/firestore/lite";

import {
    LOADING_REVIEWS, LOADING_REVIEW, FETCH_REVIEWS, ADD_TO_REVIEWS, UPDATE_REVIEWS, DELETE_FROM_REVIEWS,
    PERSONAL_VALUES_RATING_DELETE, PERSONAL_VALUES_RATING_SUCCESS,
    ADD_TO_REVIEWS_META, UPDATE_REVIEWS_META,
    FETCH_REVIEWS_ERROR, FETCH_REVIEW_ERROR
} from './types';
import { logReview } from '../lib/analyticsEvents';

export const getUserEpisodeReview = (userUID, episodeInfo) => async (dispatch, getState) => {
    const episodeId = cleanGUID(episodeInfo); // 
    const reviewId = createReviewId(episodeId, userUID); // 
    const prevFetchedReview = getState().reviewsState && getState().reviewsState[`${reviewId}`];
    console.dir(prevFetchedReview);
    if (!prevFetchedReview) { // based on latest fetch time
        console.log('startedFetch');
        dispatch({
            type: LOADING_REVIEW,
            payload: { loadingReview: true }
        })
        dispatch({
            type: FETCH_REVIEW_ERROR,
            error: false
        })
        getDoc(doc(firestore, `reviews`, reviewId))
            .then((doc) => {
                if (doc.exists()) {
                    console.log("Document data:", doc.data());
                    // let review = {};
                    const newEpisodeReview = doc.data() || {};
                    newEpisodeReview['id'] = doc.id;

                    console.dir(newEpisodeReview);
                    dispatch({
                        type: ADD_TO_REVIEWS,
                        payload: { reviewId, newEpisodeReview } // { userID: getIdFromUID(userUID), newEpisodeReview }
                    })
                } else {
                    // doc.data() will be undefined in this case
                    console.log("No such document!");
                    dispatch({
                        type: FETCH_REVIEW_ERROR,
                        error: true
                    })
                }
                dispatch({
                    type: LOADING_REVIEW,
                    payload: { loadingReview: false }
                })
            })
            .catch((err) => {
                console.error(err);
                // reject({ err: err });
                dispatch({
                    type: LOADING_REVIEW,
                    payload: { loadingReview: false }
                })
                dispatch({
                    type: FETCH_REVIEW_ERROR,
                    error: true
                })
            })
    }
};

export const getEpisodeReviews = (userUID, ratingFilter) => async (dispatch, getState) => {
    const userID = getIdFromUID(userUID);
    const prevFetchedTimeObj = getState().reviewsMetadata && getState().reviewsMetadata[`${userID}`] && getState().reviewsMetadata[`${userID}`].latestFetchDate;
    const prevFetchedTime = prevFetchedTimeObj && prevFetchedTimeObj[`rating${ratingFilter}`];
    console.dir(prevFetchedTime);
    if (!prevFetchedTime) { // based on latest fetch time
        console.dir(prevFetchedTime);
        console.log('startedFetch');
        dispatch({
            type: LOADING_REVIEWS,
            payload: { loadingReviews: true }
        })
        dispatch({
            type: FETCH_REVIEWS_ERROR,
            error: false
        })
        getDocs(query(collection(firestore, "reviews"), where("user.id", "==", userID), where("rating", "==", ratingFilter),
            orderBy('lastModifiedDate', 'desc'), limit(reviewsLimit)))
            .then((querySnapshot) => {
                var reviews = {};
                let finalLastModifiedDate;
                const querySnapshotSize = querySnapshot.size;
                let i = 1;
                querySnapshot.forEach(function (doc) {
                    // doc.data() is never undefined for query doc snapshots
                    // console.log(doc.id, " => ", doc.data());
                    const reviewData = doc.data();
                    const reviewId = doc.id;
                    // reviews.push();
                    // reviews[`${reviewData.guid}`] = reviewData;
                    reviews[`${reviewId}`] = reviewData;
                    reviews[`${reviewId}`]['id'] = doc.id;
                    if (i === querySnapshotSize) {
                        finalLastModifiedDate = reviewData.lastModifiedDate;
                    }
                    i++;
                });

                console.log('reviews');
                console.dir(reviews);
                // resolve({ success: true, favorites: reviews });
                // let reviewState = {};
                // reviewState[userID] = reviews;
                dispatch({
                    type: FETCH_REVIEWS,
                    payload: reviews
                })
                const now = new Date().getTime();
                const reviewsMeta = {};
                reviewsMeta[`${userID}`] = {
                    latestFetchDate: { [`rating${ratingFilter}`]: now },
                    finalLastModifiedDate: { [`rating${ratingFilter}`]: finalLastModifiedDate }
                };
                console.log('reviewsMeta : ' + JSON.stringify(reviewsMeta));
                dispatch({
                    type: ADD_TO_REVIEWS_META,
                    payload: reviewsMeta
                })
                dispatch({
                    type: LOADING_REVIEWS,
                    payload: { loadingReviews: false }
                })
            })
            .catch((err) => {
                console.error(err);
                // reject({ err: err });
                dispatch({
                    type: LOADING_REVIEWS,
                    payload: { loadingReviews: false }
                })
                dispatch({
                    type: FETCH_REVIEWS_ERROR,
                    error: true
                })
            })
    }
};

export const getMoreEpisodeReviews = (userUID, ratingFilter) => async (dispatch, getState) => {
    // dispatch({
    //     type: LOADING_REVIEWS,
    //     payload: { loadingReviews: true }
    // })
    const userID = getIdFromUID(userUID);
    const finalLastModifiedDateObj = getState().reviewsMetadata && getState().reviewsMetadata[`${userID}`] && getState().reviewsMetadata[`${userID}`].finalLastModifiedDate;
    const lastModifiedDate = finalLastModifiedDateObj && finalLastModifiedDateObj[`rating${ratingFilter}`];
    // const finalTimeStamp = reviewsMetadata[userID] && reviewsMetadata[userID].finalLastModifiedDate && reviewsMetadata[userID].finalLastModifiedDate[filterType];

    console.log('lastModifiedDate : ' + JSON.stringify(lastModifiedDate));
    const lastModifiedDateFin = (lastModifiedDate && lastModifiedDate.seconds) ? new Date(lastModifiedDate.seconds * 1000) : new Date();
    console.log('lastModifiedDateFin : ' + lastModifiedDateFin);
    getDocs(query(collection(firestore, "reviews"), where("user.id", "==", getIdFromUID(userUID)),
        where("rating", "==", ratingFilter), where('lastModifiedDate', '<', lastModifiedDateFin),
        orderBy('lastModifiedDate', 'desc'), limit(reviewsLimit)))
        .then((querySnapshot) => {
            const querySnapshotSize = querySnapshot.size;
            if (querySnapshotSize > 0) {
                var reviews = {};
                let finalLastModifiedDate;
                let i = 1;
                querySnapshot.forEach(function (doc) {
                    const reviewData = doc.data();
                    const reviewId = doc.id;
                    reviews[`${reviewId}`] = reviewData;
                    reviews[`${reviewId}`]['id'] = doc.id;
                    if (i === querySnapshotSize) {
                        finalLastModifiedDate = reviewData.lastModifiedDate;
                    }
                    i++;
                });
                console.dir(reviews);
                dispatch({
                    type: FETCH_REVIEWS,
                    payload: reviews
                });
                const updateReviewsMeta = {
                    userID: `${getIdFromUID(userUID)}`, ratingFilter: ratingFilter,
                    entity: 'finalLastModifiedDate', entityValue: finalLastModifiedDate
                };
                console.log('updateReviewsMeta : ' + JSON.stringify(updateReviewsMeta));
                // reviewsMeta[`${getIdFromUID(userUID)}`] = { finalLastModifiedDate: finalLastModifiedDate };
                dispatch({
                    type: UPDATE_REVIEWS_META,
                    payload: updateReviewsMeta
                })
                // dispatch({
                //     type: LOADING_REVIEWS,
                //     payload: { loadingReviews: false }
                // })
            }
        })
        .catch((err) => {
            console.error(err);
            // reject({ err: err });
            // dispatch({
            //     type: LOADING_REVIEWS,
            //     payload: { loadingReviews: false }
            // })
        })
};

export const createEpisodeReview = (userUID, userName, userPicUrl, episodeInfo, rating, comment, privacyType) => async dispatch => {
    // const db = await loadDB();
    // const backupIdCleaned = backupId.replace(/ /g, '_');
    var guidCleaned
    if (typeof episodeInfo.guid !== 'undefined') {
        guidCleaned = cleanFirebaseId(episodeInfo.guid);
    }
    const episodeId = cleanGUID(episodeInfo); // guidCleaned || backupIdCleaned;
    const reviewId = createReviewId(episodeId, userUID); // episodeId + '_userId_' + userUID;
    var newEpisodeReview = {
        episode: {
            ...createEpisodeObj(episodeInfo),
        },
        ...createReview({ rating: rating, comment: comment, privacyType: privacyType }),
        // rating: rating,
        // postedDate: firebase.firestore.Timestamp.fromDate(new Date()), // firebase.firestore.FieldValue.serverTimestamp(),
        // lastModifiedDate: firebase.firestore.Timestamp.fromDate(new Date()), // firebase.firestore.FieldValue.serverTimestamp(),
        // isPrivate: isPrivate,
        user: {
            id: getIdFromUID(userUID),
            name: userName || '',
            picUrl: userPicUrl || '',
        },
    };
    var personalRatingUpdate = {};
    personalRatingUpdate[`${guidCleaned}`] = {
        'rating': rating,
        'collectionId': episodeInfo.collectionId,
        'lastPlayed': Timestamp.now()
    };
    if (privacyType === 'public') {
        personalRatingUpdate[`${guidCleaned}`]['privacyType'] = 'public';
    }
    logReview(episodeInfo.guid, episodeInfo.collectionId, rating, privacyType, 1);
    return setDoc(doc(firestore, `reviews`, reviewId), newEpisodeReview, { merge: true })
        .then(() => {
            console.log('success');
            setDoc(doc(firestore, `users/${userUID}/personal`, 'ratings'), { values: personalRatingUpdate }, { merge: true });
        })
        .then(() => {
            // resolve({ success: true, personalRatingUpdate: personalRatingUpdate })
            newEpisodeReview['id'] = reviewId;
            dispatch({
                type: ADD_TO_REVIEWS,
                payload: { reviewId, newEpisodeReview } // { userID: getIdFromUID(userUID), newEpisodeReview }
            })
            return ({ success: true, personalRatingUpdate: personalRatingUpdate });
        })
        .catch((error) => {
            console.error("Error adding document: ", error);
            throw error;
            // return ({ success: false });
            // reject({ error: error });
        });
};

export const editEpisodeReview = (userUID, userName, userPicUrl, episodeInfo, rating, comment, privacyType) => async dispatch => {
    // const db = await loadDB();
    const backupId = episodeInfo.author + '-' + episodeInfo.pubDate;
    const backupIdCleaned = backupId.replace(/ /g, '_');
    var guidCleaned;
    if (typeof episodeInfo.guid !== 'undefined') {
        guidCleaned = cleanFirebaseId(episodeInfo.guid);
    }
    const episodeId = guidCleaned || backupIdCleaned;
    const reviewId = createReviewId(episodeId, userUID); // episodeId + '_userId_' + userUID;
    var newEpisodeReview = {
        // ...createEpisodeObj(episodeInfo),
        ...createReview({ rating: rating, comment: comment, privacyType: privacyType, edit: true }),
        // rating: rating,
        // // postedDate: firebase.firestore.Timestamp.fromDate(new Date()), // firebase.firestore.FieldValue.serverTimestamp(),
        // lastModifiedDate: firebase.firestore.Timestamp.fromDate(new Date()), // firebase.firestore.FieldValue.serverTimestamp(),
        // privacyType: privacyType
    };
    var personalRatingUpdate = {};
    personalRatingUpdate[`${guidCleaned}`] = {
        rating: rating,
        collectionId: episodeInfo.collectionId,
        lastPlayed: Timestamp.now()
    };
    console.dir(privacyType);
    if (privacyType === 'public') {
        personalRatingUpdate[`${guidCleaned}`]['privacyType'] = 'public';
    } else {
        personalRatingUpdate[`${guidCleaned}`]['privacyType'] = deleteField();
    }
    console.dir(personalRatingUpdate);
    logReview(episodeInfo.guid, episodeInfo.collectionId, rating, privacyType, 2);
    return setDoc(doc(firestore, 'reviews', reviewId), newEpisodeReview, { merge: true })
        .then(() => {
            console.log('success');
            setDoc(doc(firestore, `users/${userUID}/personal`, 'ratings'), { values: personalRatingUpdate }, { merge: true })
        })
        .then(() => {
            // resolve({ success: true, personalRatingUpdate: personalRatingUpdate })
            setTimeout(() => {
                console.log('in timeout');
                dispatch({
                    type: UPDATE_REVIEWS,
                    payload: { reviewId, newEpisodeReview }
                })
            }, 100);
            return ({ success: true, personalRatingUpdate: personalRatingUpdate });
        })
        .catch((error) => {
            console.error("Error adding document: ", error);
            throw error;
            // reject({ error: error });
        });
};

export const setEpisodeRating = (personalRatingUpdate) => async dispatch => {
    console.dir(personalRatingUpdate);
    dispatch({
        type: PERSONAL_VALUES_RATING_SUCCESS,
        payload: personalRatingUpdate
    });
};

export const deleteReview = (userUID, guid, collectionId) => async dispatch => {
    var guidCleaned;
    if (typeof guid !== 'undefined') {
        guidCleaned = cleanFirebaseId(guid);
    }
    const episodeId = guidCleaned;
    const reviewId = createReviewId(episodeId, userUID); // episodeId + '_userId_' + userUID;
    var personalRatingUpdate = {};
    personalRatingUpdate[`${guidCleaned}`] = deleteField();
    //  {
    //     rating: firebase.firestore.FieldValue.delete()
    // };
    dispatch({
        type: DELETE_FROM_REVIEWS,
        payload: reviewId
    });
    logReview(guid, collectionId, -1, '', 0);
    deleteDoc(doc(firestore, 'reviews', reviewId))
        .then(() => {
            console.log('success');
        })
        .then(() => {
            // resolve({ success: true, personalRatingUpdate: personalRatingUpdate })
            dispatch({
                type: PERSONAL_VALUES_RATING_DELETE,
                payload: guidCleaned
            })
            // return ({ success: true, personalRatingUpdate: personalRatingUpdate });
        })
        .catch((error) => {
            console.error("Error adding document: ", error);
            // reject({ error: error });
        });

    setDoc(doc(firestore, `users/${userUID}/personal`, 'ratings'), { values: personalRatingUpdate }, { merge: true })
}

// // ThunkAction<AppState> getPodcastSeriesFavourites(
// //     String userUID, int collectionId,
// //     {bool refresh = false}) {
// //   return (Store<AppState> store) async {
// export const getPodcastSeriesFavourites = async (userUID, collectionId) => {
//     const userID = getIdFromUID(userUID);
//     // const alreadyFetched = getFetchedSeriesFavourites(collectionId);

//     // if (!alreadyFetched || refresh) {
//     // based on latest fetch time
//     print('loadingSeriesReviews');
//     // store
//     //     .dispatch(LoadingSeriesReviewsAction({ 'loadingSeriesReviews': true }));
//     // dispatch({
//     //     type: FETCH_REVIEWS_ERROR,
//     //     error: false
//     // })
//     return firebase.firestore()
//         .collection('reviews')
//         .where('user.id', '==', userID)
//         .where('rating', 'in', [4, 5])
//         .orderBy('lastModifiedDate', 'desc')
//         // .limit(utils.reviewsLimit)
//         // .getDocuments(source: refresh ? Source.server : Source.serverAndCache)
//         .get()
//         .then((querySnapshot) => {
//             let reviews = {};
//             // var finalLastModifiedDate;
//             // const querySnapshotSize = querySnapshot.documents.length;
//             // int i = 1;
//             // print('querySnapshot : ' +
//             //     querySnapshot.metadata.isFromCache.toString());
//             querySnapshot.documents.forEach((doc) => {
//                 // doc.data() is never undefined for query doc snapshots
//                 // console.log(doc.id, " => ", doc.data());
//                 const reviewData = doc.data();
//                 const reviewId = doc.documentID;
//                 // reviews.push();
//                 // reviews[`${reviewData.guid}`] = reviewData;
//                 reviewData['id'] = reviewId;

//                 reviews['${reviewId}'] = reviewData; // ReviewModel.fromJson(reviewData);
//                 // if (i == querySnapshotSize) {
//                 //     finalLastModifiedDate = reviewData['lastModifiedDate'];
//                 // }
//                 // i++;
//             });

//             console.dir(reviews);
//             // store.dispatch(FetchReviewsAction(reviews));
//             return reviews;
//             // store.dispatch(
//             //     LoadingSeriesReviewsAction({ 'loadingSeriesReviews': false }));
//         })
//         .catch((err) => {
//             console.error(err);
//             // store.dispatch(
//             //     LoadingSeriesReviewsAction({ 'loadingSeriesReviews': false }));
//         });
// }